module.exports = "/images/rs.svg?d2589c3db9bf2acc415eb0f9ad125ea8";